import tukasLogo from '@/images/clients/tukas.svg'
import type { IPartnerSettings } from '.'

export const TUkas: IPartnerSettings = {
  partner: 'TUkas',
  origAppUrl: {
    development: 'https://localhost/Car.Web.Client.CommonClient',
    test: 'https://broker.cebia.cz/test',
    prep: 'https://broker.cebia.cz/prep',
    production: 'https://broker.cebia.cz/prod',
  },
  hosts: [
    'srovnavac.tukas.cz'
    //, 'localhost:44470'
  ],
  logo: tukasLogo
}
